// @flow

import type {ApplicationRedux} from 'redux/ApplicationRedux';
import type {BaseState} from 'redux/uiState/layout/base/BaseState';
import type {BookingState} from 'redux/uiState/layout/booking/BookingState';

import {layoutState} from 'redux/uiState/UiState';

export type LayoutState = {
  base: BaseState,
  booking: BookingState,
};

export const baseState = (state: ApplicationRedux): BaseState =>
  layoutState(state).base;

export const bookingState = (state: ApplicationRedux): BookingState =>
  layoutState(state).booking;
